import { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import styles from "./styles.module.css";
import ReactLoading from "react-loading";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useNavigate, useParams } from "react-router-dom";

type Props = {
  isOpen: boolean;
  setOpenModal: (value: boolean) => void;
  typeModal:
    | "process"
    | "error_payment"
    | "error_payment_totvs"
    | "error_connection";

  errorInfo?:string
};

const ModalFinalizaVendaFood: FC<Props> = ({
  isOpen,
  setOpenModal,
  typeModal,
  errorInfo
}) => {
  const [config, setConfig] = useState<any>();
  const { getAppConfig } = useAppConfig();
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();

  async function loadConfig() {
    setConfig(await getAppConfig());
  }

  useEffect(() => {
    loadConfig();
  }, []);

  function traslateTypeModalTitle() {
    switch (typeModal) {
      case "process":
        return "Processando pagamento";
      case "error_connection":
        // return 'Processando pagamento'
        return "Pedido a caminho";
      case "error_payment":
        return "Erro ao processar o pagamento";
      case "error_payment_totvs":
        return "Pagamento realizado,finalize no caixa.";
    }
  }

  function traslateTypeModalMessage() {
    switch (typeModal) {
      case "process":
        return "Por favor, aguarde enquanto verificamos todos os dados e concluímos o seu pagamento.";
      case "error_connection":
        // return 'Conexão instável, tentando enviar pedido novamente'
        return "O sistema que recebe os pedidos está demorando um pouco mais para responder. Não se preocupe, estamos tentando novamente.";
      case "error_payment":
        return "Não foi possível completar o pagamento do seu pedido. Por favor verifique os dados informados e tente novamente.";
      case "error_payment_totvs":
        return "Seu pagamento foi processado, porém houve um imprevisto ao concluir a transação. Dirija-se ao caixa para finalizar.";
    }
  }

  function goToOrder() {
    navigate(`/${pluginspace_id}/order`);
    return null;
  }

  function goToCardapio() {
    navigate(`/${pluginspace_id}/products`);
    return null;
  }

  function handleFinishAction() {
    switch (typeModal) {
      case "error_payment":
        return goToOrder();
      case "error_payment_totvs":
        return goToCardapio();
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setOpenModal(false)}
      className={styles.modal}
      contentLabel={"Processando pagamento"}
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className={styles.modal_body}>
        <div className={styles.modal_content_main}>
          <div className={styles.modal_content}>
            <div className={styles.modal_header}>
              <h4>{traslateTypeModalTitle()}</h4>
            </div>
            <div className={styles.body}>
              <div>
                <span>{errorInfo ? errorInfo: traslateTypeModalMessage()}</span>
              </div>
              {(typeModal === "process" ||
                typeModal === "error_connection") && (
                <div className={styles.loading_box}>
                  <ReactLoading
                    type={"spinningBubbles"}
                    color={"#000"}
                    height={"72px"}
                    width={"72px"}
                  />
                </div>
              )}
            </div>
            {(typeModal === "error_payment" ||
              typeModal === "error_payment_totvs") && (
              <div className={styles.button_box}>
                <button
                  onClick={handleFinishAction}
                  style={{
                    background: config?.webappcolor.webappbutton
                      ? config?.webappcolor.webappbutton
                      : "#EAEAEA",
                    color: config?.webappcolor.fontbutton
                      ? config?.webappcolor.fontbutton
                      : "#636363",
                  }}
                >
                  {" "}
                  {typeModal === "error_payment"
                    ? "Voltar ao Pagamento"
                    : "Entendi"}{" "}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export { ModalFinalizaVendaFood };
